/**
 * Offer Details page module.
 * Refactored to use shared modules.
 */

import { setupLoadMorePrices } from '../modules/offer/load-more-prices';
import { initUnitModal } from './offer-batch-modals';
import { init as initBulkPrices } from './offer-bulk-prices';
import { init as initInlineEdit } from './offer-inline-edit';
import { init as initModalEdit } from './offer-modal-edit';

document.addEventListener('DOMContentLoaded', () => {
    // Load more prices
    setupLoadMorePrices();

    // Container & data attributes
    const container = document.getElementById('offer-details-container') as HTMLElement | null;
    if (!container) return;

    const offerId = parseInt(container.dataset.offerId || '0', 10);
    const offerName = container.dataset.offerName || '';
    const offerGroup = container.dataset.offerGroup || '';
    const urlCreateUnits = container.dataset.urlCreateUnits || '';
    const urlUnitFormData = container.dataset.urlUnitFormData || '';

    initUnitModal({
        urlCreateUnits,
        urlUnitFormData,
        fixedOfferId: offerId,
        fixedOfferName: offerName,
        fixedOfferGroup: offerGroup,
        capsShowClassification: container.dataset.capsShowClassification === 'true',
        capsShowService: container.dataset.capsShowService === 'true',
    });
    initBulkPrices();
    initInlineEdit();
    initModalEdit();
});
